import { render, staticRenderFns } from "./BdWeWorkThird.vue?vue&type=template&id=4e5dd16c&"
import script from "./BdWeWorkThird.vue?vue&type=script&lang=js&"
export * from "./BdWeWorkThird.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports